export default function() {
  'ngInject';
  return function(fileName) {
    if (!fileName) return 'File';
    if (fileName.length > 32) return fileName.substring(32, fileName.length);
    if (fileName.length > 20) {
      const names = fileName.split('.');
      const fileStart = names[0].substring(0, 16);
      return `${fileStart}... ${names[1]}`;
    }
    return fileName;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/FileName.js